export default __webpack_public_path__ + "static/media/chairs-bg-1.fe5cfce7.png";